import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=56984814&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=ts"
export * from "./AddProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./AddProjectModal.vue?vue&type=style&index=0&id=56984814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56984814",
  null
  
)

export default component.exports